export const normalizeShortRole = (role: string) => {
    switch (role.toUpperCase()) {
        case 'MC':
            return 'mnemo_creative';
        case 'ME':
            return 'editor';
        case 'LP':
            return 'language_professional';
    }
};
